var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button", id: "excel" },
              on: { click: _vm.imprimirExcel }
            },
            [
              _c("i", {
                staticClass: "fa fa-file-excel-o",
                attrs: { "aria-hidden": "true" }
              }),
              _c("span", [_vm._v("Excel")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-info btn--bigger",
              attrs: { type: "button", id: "consultar" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", {
                staticClass: "fa fa-search",
                attrs: { "aria-hidden": "true" }
              }),
              _c("span", [_vm._v("Consultar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-7" }, [
            _c("div", { staticClass: "form-inline" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: { name: "tipo_fecha", type: "radio", value: "H" },
                  domProps: { checked: _vm._q(_vm.form.tipo_fecha, "H") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipo_fecha", "H")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Hoy")])
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: { name: "tipo_fecha", type: "radio", value: "A" },
                  domProps: { checked: _vm._q(_vm.form.tipo_fecha, "A") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipo_fecha", "A")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Ayer")])
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: { name: "tipo_fecha", type: "radio", value: "P" },
                  domProps: { checked: _vm._q(_vm.form.tipo_fecha, "P") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipo_fecha", "P")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Personalizado")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_fecha === "P",
                      expression: "form.tipo_fecha === 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "desde",
                          locale: "es",
                          "no-label": "",
                          "only-date": "",
                          "auto-close": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.fecha_desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fecha_desde", $$v)
                          },
                          expression: "form.fecha_desde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Desde")])
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_fecha === "P",
                      expression: "form.tipo_fecha === 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "hasta",
                          locale: "es",
                          "no-label": "",
                          "only-date": "",
                          "auto-close": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.fecha_hasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fecha_hasta", $$v)
                          },
                          expression: "form.fecha_hasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Hasta")])
                    ],
                    1
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-5" }, [
            _c("div", { staticClass: "form-group select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.todos_usuarios,
                        expression: "!form.todos_usuarios"
                      }
                    ],
                    attrs: {
                      multiple: "",
                      id: "usuarios",
                      placeholder: "Seleccione...",
                      options: _vm.usuarios,
                      label: "nombre"
                    },
                    model: {
                      value: _vm.usuariosSeleccionados,
                      callback: function($$v) {
                        _vm.usuariosSeleccionados = $$v
                      },
                      expression: "usuariosSeleccionados"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "usuarios" } }, [
                    _vm._v("Usuarios:")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "todos_usuarios" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.todos_usuarios,
                      expression: "form.todos_usuarios"
                    }
                  ],
                  attrs: { type: "checkbox", id: "todos_usuarios" },
                  domProps: {
                    checked: Array.isArray(_vm.form.todos_usuarios)
                      ? _vm._i(_vm.form.todos_usuarios, null) > -1
                      : _vm.form.todos_usuarios
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.todos_usuarios,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "todos_usuarios",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "todos_usuarios",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "todos_usuarios", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Todos")])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c("vue-good-table", {
                attrs: {
                  columns: [
                    {
                      label: "FECHA",
                      field: "fecha"
                    },
                    {
                      label: "NOMBRE",
                      field: "nombre_persona"
                    },
                    {
                      label: "USUARIO",
                      field: "nombre_usuario"
                    },
                    {
                      label: "IP",
                      field: "ip"
                    }
                  ],
                  "pagination-options": {
                    enabled: true,
                    perPage: 20,
                    perPageDropdown: [],
                    nextLabel: "siguiente",
                    prevLabel: "anterior",
                    rowsPerPageLabel: "Registros por página",
                    ofLabel: "de",
                    allLabel: "Todo",
                    dropdownAllowAll: true
                  },
                  rows: _vm.registros,
                  "search-options": {
                    enabled: true,
                    placeholder: "Buscar..."
                  },
                  styleClass: "vgt-table vgt-table--sticky"
                }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Logs de inicio de sesión")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("p", [_c("strong", [_vm._v("Fecha:")])])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cca23f38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cca23f38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/LogsLogin.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cca23f38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/LogsLogin.vue
// module chunks = 0